function Card(props) {
  return (
    <article className="card">
      <div className="card-media">
        <img
          alt=""
          src={process.env.PUBLIC_URL + "/img/landing/" + props.img}
          className="img-fluid"
        />
      </div>
      <h3 className="card-title">{props.title}</h3>
      <p className="card-text">{props.text}</p>
    </article>
  );
}

export default Card;
